<template>
  <div style="background-color: #f5f5f5" id="char">
    <div class="features">
      <div class="mainContent">
        <div class="moduleTitle">软件特色</div>
        <div class="titleDesc">专业翻译通讯技术沉淀，专注即时通讯翻译领域</div>
        <div class="mainBox">
          <div v-for="(item, idx) in mainList" :key="idx">
            <img :src="item.img" alt="" />
            <div class="imgTitle">{{ item.title }}</div>
            <div class="imgDesc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import key from "@/assets/imgs/index/key.svg";
import magic from "@/assets/imgs/index/magic.svg";
import rocket from "@/assets/imgs/index/rocket.svg";
const mainList = [
  {
    img: key,
    title: "热门软件支持",
    desc: "支持Telegram WhatsApp Line等 持续开发各种聊天软件对接.",
  },
  {
    img: magic,
    title: "无需招聘专业翻译",
    desc: "任何人可以学习和操作，只需要会打字即可。招聘学习门槛低，入门简单.",
  },
  {
    img: rocket,
    title: "180个行业和类目",
    desc: "不限制业行与类目，所有项目都可操作，支持全球大部分语言翻译.",
  },
];
</script>
<style scoped lang="scss">
.features {
  background-color: #fff;
  padding: 10rem 0;
}
.titleDesc {
  color: #95a5a6;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 400;
  margin: 0.5rem 0;
  text-align: center;
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.mainContent {
  position: relative;
}
.mainBox {
  margin-top: 4rem;
  display: flex;
  justify-content: space-between;
  padding-top: 2rem;
  > div {
    width: 30%;
    text-align: center;
    > img {
      display: inline-block;
      height: 160px;
      width: 160px;
      transition: all 0.2s ease;
      margin: 24px 0;
      &:hover {
        transform: rotate(-45deg);
      }
    }
    .imgTitle {
      color: #34495e;
      font-size: 1.5rem;
      margin-bottom: 12px;
    }
    .imgDesc {
      font-size: 1rem;
      color: #95a5a6;
    }
  }
}
@media (max-width: 768px) {
  .features {
    padding: 2.5rem 0.75rem 1rem;
  }
  .mainBox {
    flex-wrap: wrap;
    > div {
      width: 100%;
      text-align: center;
    }
  }
}
</style>